export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BusModal.vue?vue&type=template&id=47c82486&"


//////////////////
// WEBPACK FOOTER
// ./src/components/BusModal.vue?vue&type=template&id=47c82486&
// module id = 546
// module chunks = 0